module.exports = __webpack_public_path__ + "static/media/productCards.2d84fc9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/app-composer/concierge/images/productCards.png
// module id = 272
// module chunks = 0